import React from 'react';

const Img = (props) => {
    const { filename } = props;
    return <img src={ `/static/images/${ filename }` } { ...props } />;
};

export default Img;
